import React from "react";
import { Link } from "react-router-dom";
import "./Header.css";

const Header = () => {
  return (
    <div className="header-wrapper">

      {/* ===== TOP HEADER ===== */}

      <header className="header">

        {/* LEFT LOGO */}

        <div className="header-left">
          <img
            src={`${process.env.PUBLIC_URL}/images/sj1.jpg`}
            alt="National Emblem"
          />
        </div>

        {/* CENTER TEXT */}

        <div className="header-center">

          <h2>ग्रामपंचायत सायकी</h2>
          <h3>पंचायत समिती उमरेड, जिल्हा परिषद नागपूर</h3>
          <h3>महाराष्ट्रातील एकमेव ग्रामपंचायत उपक्रम</h3>

          <h2 className="iso-text">9001:2015 Certified</h2>

          <img
            src={`${process.env.PUBLIC_URL}/images/iso.png`}
            alt="ISO"
            className="iso-img"
          />

        </div>

        {/* RIGHT IMAGES */}

        <div className="header-right">

          <img
            src={`${process.env.PUBLIC_URL}/images/raje.jpg`}
            alt="raje"
          />

          <img
            src={`${process.env.PUBLIC_URL}/images/Gadgemaharaj.jpg`}
            alt="gadge"
          />

          <img
            src={`${process.env.PUBLIC_URL}/images/tujdojimaharaj.jpeg`}
            alt="tukdoji"
          />

        </div>

      </header>


      {/* ===== MARQUEE ===== */}

      <div className="marquee-bar">
        <marquee>
          ग्रामपंचायत सायकी – तालुका उमरेड – जिल्हा नागपूर  फोन न.:8669393515
        </marquee>
      </div>


      {/* ===== MAIN MENU ===== */}

      <nav className="menu-main">

        <Link to="/aboutus">ग्रामपंचायत-बद्दल</Link>
        <Link to="/">मुखपृष्ठ</Link>
        <Link to="/gramsevakpage">ग्रामपंचाय अधिकारी</Link>
        <Link to="/gallery">छायाचित्र</Link>
        <Link to="/vikas">विकास कामे</Link>
        <Link to="/sabha">सभेची माहिती</Link>
        <Link to="/contact">संपर्क करा</Link>
        <Link to="/info">ग्रामपंचायत माहिती</Link>
        <Link to="/team">सदस्य</Link>

      </nav>


      {/* ===== SUB MENU ===== */}

      <nav className="menu-sub">

        <Link to="/janmdakhala">जन्म दाखला</Link>
        <Link to="/death">मृत्यू दाखला</Link>
        <Link to="/vivah">विवाह दाखला</Link>
        <Link to="/sarpanch">सरपंच कार्यकाल</Link>
        <Link to="/upsarpanch">उपसरपंच कार्यकाल</Link>
        <Link to="/abc">पुरस्कार</Link>
        <Link to="/sadasya">सदस्य कार्यकारणी</Link>

      </nav>

    </div>
  );
};

export default Header;